// UTM capture (first-touch attribution) + dynamic WhatsApp URL builder
// UTMs are captured on any page load and persisted in localStorage,
// so if a user lands from TikTok via /hello?utm_source=tiktok and later
// clicks WhatsApp from a different page, we still know the origin.

const STORAGE_KEY = "angiolini_utm";
const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
];

const readCurrentUtm = () => {
  const params = new URLSearchParams(window.location.search);
  const out = {};
  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) out[k] = v.slice(0, 60);
  });
  return out;
};

export const captureUtmOnce = () => {
  try {
    const current = readCurrentUtm();
    if (Object.keys(current).length === 0) return;
    const payload = { ...current, ts: Date.now() };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (_) {
    /* localStorage disabled */
  }
};

export const getStoredUtm = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.ts || Date.now() - parsed.ts > TTL_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return parsed;
  } catch (_) {
    return null;
  }
};

const SOURCE_LABEL_RU = {
  tiktok: "TikTok",
  instagram: "Instagram",
  facebook: "Facebook",
  whatsapp: "WhatsApp Status",
  whatsapp_status: "WhatsApp Status",
  telegram: "Telegram",
  youtube: "YouTube",
  google: "Google",
  yandex: "Yandex",
  direct: "Прямой заход",
  qr: "QR-код",
};

const humanSource = (utm) => {
  if (!utm) return "";
  const src = (utm.utm_source || "").toLowerCase();
  if (!src) return "";
  return SOURCE_LABEL_RU[src] || utm.utm_source;
};

const WHATSAPP_PHONE = "77018017755";
const BASE_MSG = "Здравствуйте! Пишу с сайта Angiolini. Хочу подобрать верхнюю одежду.";

export const buildWhatsAppUrl = () => {
  // Prefer current URL utms, fall back to stored
  const current = readCurrentUtm();
  const utm =
    Object.keys(current).length > 0 ? current : getStoredUtm() || {};
  const label = humanSource(utm);
  const campaignSuffix =
    utm.utm_campaign ? ` · ${utm.utm_campaign}` : "";
  const originLine = label
    ? `\n\n(Пришёл из: ${label}${campaignSuffix})`
    : "";
  const msg = BASE_MSG + originLine;
  return `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(msg)}`;
};
